import React from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Image from 'react-bootstrap/Image';
import imgSrcMAC from './img/LOGOTIPO_HOSPITALES_MAC_1.png';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';

const BarraNavegacion = ({handleShowMenu}) => {
    return (
    <div className='nav_bar'>
        <Navbar variant="light" className='justify-content-center'>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                    <Row className="align-items-center" xs={12} md={12} lg={12}>
                        <Col md={{ span: 1 }}>
                            <i className="btn btn-lg bi bi-list-task"  onClick={()=>{handleShowMenu()}}></i>
                        </Col>
                        <Col md={{ span: 3, offset: 4 }} style={{color: 'white'}}>
                            Gestor de tiempos de proyectos Ver. 1.0.0     
                        </Col>
                        <Col md={{ offset: 2 }}>
                            <Image src={imgSrcMAC} width="20%" />
                        </Col>
                    </Row>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
        <Row xs={12} md={12} lg={12}>
            <Col xs={{ span: 12}} md={{ span: 12}} >
            
            </Col>
        </Row>
        <br/>
    </div>
    )
}

export default BarraNavegacion;
